import { Box, Flex, SimpleGrid, IconButton, Icon } from "@chakra-ui/react";
import { BiChevronUp } from "react-icons/bi";

const ParticipantsSingleView = ({
  containerRef,
  handleScroll,
  renderParticipantType,
}) => {
  return (
    <Box my="10px" overflow="hidden" height="100%">
      <Flex alignItems="center" justifyContent="center" direction="column" height="100%">
        <IconButton
          variant="ghostIconButton"
          icon={
            <Icon as={BiChevronUp} color="purple.25" w="30px" h="30px" />
          }
          _hover={{ opacity: 1 }}
          opacity="0.5"
          onClick={() => handleScroll(-60)}
        />
        <Box
          ref={containerRef}
          height="100%"
          width="90px"
          overflowY="scroll"
          sx={{
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <SimpleGrid spacing="3" justifyItems="center" margin="7px">
            {renderParticipantType()}
          </SimpleGrid>
        </Box>
        <IconButton
          variant="ghostIconButton"
          icon={
            <Icon as={BiChevronUp} color="purple.25" w="30px" h="30px" />
          }
          transform="rotate(-180deg)"
          _hover={{ opacity: 1 }}
          opacity="0.5"
          onClick={() => handleScroll(60)}
        />
      </Flex>
    </Box>
  );
};

export default ParticipantsSingleView;
